export default __webpack_public_path__ + "static/background_paw_prints-7d775842335b1ba6151e4907b6debb78.png";